import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CacheBuster from './CacheBuster';
import SiteProvider from './context/SiteProvider';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import './i18next/i18next';
import { initI18n } from './i18next/i18next';

const start = async () => {
    await initI18n();

    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );

    root.render(
        <BrowserRouter>
            <CacheBuster>
                <SiteProvider>
                    <App />
                </SiteProvider>
            </CacheBuster>
        </BrowserRouter>
    );
};

start();
